exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-items{display:flex;flex-direction:row;justify-content:center;width:100%}.content-items--list{flex-direction:column}.content-items--list .content-items__item{margin:0;max-width:100%;width:100%}.content-items--grid .content-items__grid{display:flex;flex-direction:row;flex-wrap:wrap;height:100%;justify-content:space-around;overflow-y:hidden;width:100%}.content-items--grid .content-items__item{margin:0;min-width:256px}.content-items--carousel{display:block}@media (min-width: 1024px){.content-items--gutters{padding:0 40px}}.content-items__item{margin:0 auto;max-width:256px}.content-items__show-more{margin-top:20px;text-align:center}.content-items ::-webkit-scrollbar{background:transparent;width:0}\n", ""]);

// exports
exports.locals = {
	"content-items": "content-items",
	"content-items--list": "content-items--list",
	"content-items__item": "content-items__item",
	"content-items--grid": "content-items--grid",
	"content-items__grid": "content-items__grid",
	"content-items--carousel": "content-items--carousel",
	"content-items--gutters": "content-items--gutters",
	"content-items__show-more": "content-items__show-more"
};